export const tocScroll = () => {
    $('.arl-toc__link, .arl-toc__link--header').on(
        'click',
        function doScroll(e) {
            const clickedLink = $(this);
            const link = clickedLink.attr('href');

            const targetId = link.substring(1);

            if (!targetId) {
                return true;
            }

            const target = document.getElementById(targetId);

            target.scrollIntoView({
                behavior: 'instant',
                block: 'center',
                inline: 'nearest',
            });

            // Set the focus to the target, for a screen-reader friendly tab order!
            target.focus(); // This only works if the target (header) has a tabindex of -1 !!!!

            e.preventDefault();
            return false;
        }
    );

    $(() => {
        const urlHash = window.location.hash;

        if (!urlHash) {
            return true;
        }

        const targetId = urlHash.substring(1).toLowerCase();
        const target = document.getElementById(targetId);

        if (!target) {
            return true;
        }

        target.scrollIntoView({
            behavior: 'instant',
            block: 'center',
            inline: 'nearest',
        });

        return false;
    });
};
